module.exports = __webpack_public_path__ + "img/stock0.109c4596.png";